<template>
  <div class="admission-info-wrapper">
    <div class="admission-info">
      <div class="admission-date">
        <p class="admission-info__title">Дата приёма</p>
        <h2>
          {{
            display.smAndDown
              ? getFullDate(admissionInfo.dateTime, true)
                  .split(',')
                  .slice(0, 2)
                  .toString()
              : getFullDate(admissionInfo.dateTime, true)
          }}
        </h2>
        <span class="admission-info__time" v-if="display.smAndDown">
          {{ getTimeVisit }}
        </span>
        <h3>
          {{ admissionInfo.clinic.clinicName }}
        </h3>
        <div>
          <LocateIcon />
          <p class="admission-info__grey-text">
            {{ admissionInfo.clinic.address }}
          </p>
        </div>
        <div v-if="admissionInfo.clinic['subway-stations'].length">
          <SubwayIcon
            :color="
              admissionInfo.clinic['subway-stations'][0].color &&
              admissionInfo.clinic['subway-stations'][0].color.length
                ? `#${admissionInfo.clinic['subway-stations'][0].color[0]}`
                : 'purple'
            "
          />
          <p class="admission-info__grey-text">
            {{ admissionInfo.clinic['subway-stations'][0].title }}
          </p>
        </div>
        <div
          class="admission-info__actions"
          v-if="admissionInfo.status === 'UPCOMING'"
        >
          <CalendarEventButton :admissionInfo="admissionInfo">
            <template v-slot="{ event }">
              <Button secondary :onClick="event">
                Добавить запись в календарь
              </Button>
            </template>
          </CalendarEventButton>

          <NavigateEventButton
            v-if="display.smAndDown"
            :clinicInfo="admissionInfo.clinic"
          >
            <template v-slot="{ event }">
              <Button secondary :onClick="event">
                Построить маршрут на картах
                <LocateIcon style="margin-left: 4px" />
              </Button>
            </template>
          </NavigateEventButton>
        </div>
        <ShareEventButton :shareText="getShareText">
          <template v-slot="{ event }">
            <Button secondary class="share-visit__trigger" :onClick="event">
              <ShareIcon />
              <span v-if="!display.smAndDown">Поделиться</span>
            </Button>
          </template>
        </ShareEventButton>
      </div>
      <div v-if="type === 'analiseCard'" class="analyse-info ym-hide-content">
        <div class="patient-info">
          <p class="admission-info__title">Пациент</p>
          <h3 class="patient-info__name">
            {{
              `${admissionInfo.patient.name} ${admissionInfo.patient.surname} ${admissionInfo.patient.patronymic}`
            }}
          </h3>
          <PassportInfo
            :passport="admissionInfo.patient.ambulatoryCards[0]"
            :birthday="admissionInfo.patient.birthday"
          />
        </div>
        <div class="patient-info">
          <p class="admission-info__title">Назначивший врач</p>
          <h3 class="patient-info__name">
            {{ doctorInfo ? doctorInfo.fullName : '' }}
          </h3>
        </div>
      </div>
      <div class="patient-info ym-hide-content" v-else>
        <p class="admission-info__title">Пациент</p>
        <h3 class="patient-info__name">
          {{
            `${admissionInfo.patient.name} ${admissionInfo.patient.surname} ${admissionInfo.patient.patronymic}`
          }}
        </h3>
        <PassportInfo
          :passport="admissionInfo.patient.ambulatoryCards[0]"
          :birthday="admissionInfo.patient.birthday"
        />
      </div>
    </div>
    <div class="admission-info__details">
      <template
        v-if="
          admissionInfo.status === 'UPCOMING' || admissionInfo.status === 'OPEN'
        "
      >
        <div class="price-info" v-if="admissionInfo.price">
          <div class="price-title">
            Стоимость и оплата
            <SmTooltip
              :trigger="windowWidth >= 1024 ? 'mouseenter' : ''"
              name="admission-discount"
              :interactive="true"
            >
              <template v-slot:trigger>
                <InfoIcon />
              </template>
              <template v-slot:tooltip>
                <DiscountTooltip />
              </template>
            </SmTooltip>
          </div>
          <h2 class="price-text">
            {{ admissionInfo.price }}
          </h2>
        </div>
        <div class="button-wrapper">
          <Button
            secondary
            icon="change-time"
            :onClick="() => handleButtonClick('transfer')"
          >
            Перенести
          </Button>
          <Button
            classes="cancel"
            icon="cancel"
            :onClick="() => handleButtonClick('cancel')"
          >
            Отменить
          </Button>
        </div>
      </template>
      <template v-else>
        <div v-if="admissionInfo.status === 'FINISHED'" class="status">
          <IconSuccessRounded />
          <span>Приём завершён</span>
        </div>
        <div v-else class="status">
          <IconCancelRounded />
          <span>Приём отменён</span>
        </div>
        <RetransferButton :infoCard="admissionInfo" />
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { parseISO } from 'date-fns'

import IconSuccessRounded from '@/assets/icons/success-rounded'
import IconCancelRounded from '@/assets/icons/cancel-rounded'
import SubwayIcon from '@/assets/icons/subway'
import LocateIcon from '@/assets/icons/locate'
import InfoIcon from '@/assets/icons/info'
import ShareIcon from '@/assets/icons/share'

import { AnalysisTypes, PaymentStatusTypes } from '@/core/constants'
import { formatWithLocale, getFullDate } from '@/core/utils'
import { useDisplay } from '@/hooks'

import NavigateEventButton from '@/components/navigateEventButton'
import CalendarEventButton from '@/components/calendarEventButton'
import ShareEventButton from '@/components/shareEventButton'
import RetransferButton from '@/components/retransferButton'
import DiscountTooltip from '@/components/discountTooltip'
import PassportInfo from '@/components/passportInfo'
import SmTooltip from '@/components/tooltip'
import Button from '@/components/button'

export default {
  name: 'AdmissionInfoCard',
  components: {
    ShareEventButton,
    DiscountTooltip,
    SmTooltip,
    SubwayIcon,
    IconSuccessRounded,
    IconCancelRounded,
    Button,
    InfoIcon,
    LocateIcon,
    PassportInfo,
    RetransferButton,
    CalendarEventButton,
    NavigateEventButton,
    ShareIcon
  },
  setup() {
    const display = useDisplay()

    return {
      display
    }
  },
  data() {
    return {
      getFullDate,
      AnalysisTypes: Object.freeze(AnalysisTypes),
      PaymentStatusTypes: Object.freeze(PaymentStatusTypes)
    }
  },
  props: {
    type: String,
    admissionInfo: {
      dateTime: String,
      status: String,
      paymentStatus: String,
      doctor: String
    },
    patientInfo: {
      name: String,
      surname: String,
      birthday: String,
      barCode: String
    },
    doctorInfo: {
      fullName: String
    },
    clinicInfo: {
      clinicName: String,
      address: String
    },
    userInfo: {
      name: String,
      surname: String,
      birthday: String,
      barCode: String
    },
    handleButtonClick: {
      type: Function,
      default: () => {}
    },
    cabinet: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('account', ['getPatientInfo']),
    ...mapGetters('specialities', ['specialitiesListData']),
    getTimeVisit() {
      const time = this.getFullDate(this.admissionInfo.dateTime, true)
        .split(',')
        .slice(-1)
        .toString()
      if (this.admissionInfo.status === 'OPEN') {
        return `Кабинет ${this.admissionInfo.cabinet} в ${time}`
      }

      if (this.cabinet) {
        return `Кабинет ${this.cabinet} в ${time}`
      }

      return time
    },
    getShareText() {
      const patient = this.getPatientInfo
      const visit = this.admissionInfo

      const specialization = this.specialitiesListData.find(
        (v) => v.id === visit.specialityId
      )

      const formattedDate = formatWithLocale(
        parseISO(visit.dateTime),
        'eeee, d MMMM, HH:mm'
      )

      const date =
        formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)

      const subwayStations = () => {
        return visit.clinic['subway-stations']
          .map((v) => (v.title ? `м. ${v.title}\n` : ''))
          .join('')
      }
      let text = ''

      if (
        visit.doctor.surname &&
        visit.doctor.name &&
        visit.doctor.patronymic
      ) {
        text += `Врач:\n${visit.doctor.surname} ${visit.doctor.name} ${visit.doctor.patronymic}`
      }

      if (patient.surname && patient.name && patient.patronymic) {
        text += `\n\nПациент:\n${patient.surname} ${patient.name} ${patient.patronymic}`
      }

      if (specialization.title) {
        text += `\n\nУслуга:\n${specialization.title}`
      }

      if (visit.clinic.address) {
        text += `\n\nАдрес:\nСМ-клиника на улице: ${
          visit.clinic.address
        }\n${subwayStations()}`
      }

      text += '\nДанные о приёме:'
      // text += `\nНачало приёма - ${time}`
      text += `\nДата приёма - ${date}`

      if (visit.cabinet && visit.status !== 'UPCOMING') {
        text += `\nКабинет: ${visit.cabinet}`
      }

      text += '\nПри задержке приёма, пожалуйста, обратитесь в регистратуру'
      if (visit.price) {
        text += `\nПредварительная стоимость услуги`
        text += `${visit.price} ₽`
      }

      return text
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
